import React from 'react';

const scopeClass = (scope) => {
  const key = String(scope || '').toUpperCase();
  if (key === 'SYSTEM') return 'bg-purple-500/20 border-purple-500/60 text-purple-200';
  if (key === 'AREA') return 'bg-blue-500/20 border-blue-500/60 text-blue-200';
  if (key === 'OLT' || key === 'PON' || key === 'ODP') return 'bg-teal-500/20 border-teal-500/60 text-teal-200';
  return 'bg-slate-700 border-slate-600 text-slate-200';
};

const RiskScopeBadge = ({ scopeType, scopeKey }) => {
  return (
    <span className={`inline-flex items-center rounded-md border px-2 py-1 text-xs font-medium ${scopeClass(scopeType)}`}>
      {String(scopeType || 'UNKNOWN').toUpperCase()} � {scopeKey || '-'}
    </span>
  );
};

export default RiskScopeBadge;
